import { IXFilter } from './IXFilter';
import { IFilter, ICAMLFilter } from '../common/models';
import $ from 'jquery';

export class CAMLFilter implements IXFilter {
    public generateFilter(data: any) {
        return this.generateCAMLFilter(data);
    }

    public getFilterOperations(): string[] {
        return ['Select Operator', 'Equals', 'Not Equals', 'Contains', '<', '<=',
                '>', '>=', 'Is Null', 'Is Not Null', 'Starts With'];
    }

    public generateViewFilter( data: any): any {
        return data.view.query;
    }

    public generateField(field: any): any {
        return { internalName: field.InternalName, title: field.Title, type: field.TypeAsString, id: field.Id};
    }

    public generateDefaultField(): any {
        return { internalName: '', title: 'Select field', type: '', id: ''};
    }

    public generateDefaultValue(): any {
        return { value: 'Select value', id: ''};
    }

    public generateDefaultView(): any {
        return { title: 'Select a View', query: '' };
    }

    public generateViewObject(view: any): any {
        return { title: view.Title, query: view.ViewQuery};
    }

    public getFilterObject(query: any): IFilter[] {
        return (<ICAMLFilter>query).filters;
    }

    private generateCAMLFilter(data: any): any {
        if ( ! data.filters ) {
            return '';
        }
        let filter = '';
        for ( let i = data.filters.length - 1; i >= 0 ; i--) {
            const f = data.filters[i];
            const fAsString = this.generateFilterForField(f);
            filter = `${fAsString}${filter}`;

            if ( f.logicalOp && i !== data.filters.length - 1) {
            filter = `<${this.getLogicalOp(f.logicalOp)}>${filter}</${this.getLogicalOp(f.logicalOp)}>`;
            }
        }
        // filter = `<Where>${filter}</Where>`;
        return filter;
    }

    private getLogicalOp(op:  string) {
        switch (op) {
          case 'And':
          case 'AND':
          case '\'And\'':
          case '\'AND\'':
            return 'And';
          case 'Or':
          case 'OR':
          case '\'Or\'':
          case '\'OR\'':
            return 'Or';
        }
      }
    private generateFilterForField(flt: any): string {
        if (!flt || !flt.field || !flt.operator || !flt.value) {
            return '';
        }

        if  (!flt.field.internalName) {
            return '';
        }

        switch (flt.operator) {
            case 'Equals':
            return `<Eq><FieldRef Name='${flt.field.internalName}' /><Value Type='${flt.field.type}'>`
            + `${this.formatValue(flt.value, flt.field.type)}</Value></Eq>`;
            case 'Not Equals':
            return `<Neq><FieldRef Name='${flt.field.internalName}' /><Value Type='${flt.field.type}'>`
            + `${this.formatValue(flt.value, flt.field.type)}</Value></Neq>`;
            case 'Contains':
            return `<Contains><FieldRef Name='${flt.field.internalName}' /><Value Type='${flt.field.type}'>`
            + `${this.formatValue(flt.value, flt.field.type)}</Value></Contains>`;
            case '<=':
            return `<Leq><FieldRef Name='${flt.field.internalName}' /><Value Type='${flt.field.type}'>`
            + `${this.formatValue(flt.value, flt.field.type)}</Value></Leq>`;
            case '<':
            return `<Le><FieldRef Name='${flt.field.internalName}' /><Value Type='${flt.field.type}'>`
            + `${this.formatValue(flt.value, flt.field.type)}</Value></Le>`;
            case '>':
            return `<Ge><FieldRef Name='${flt.field.internalName}' /><Value Type='${flt.field.type}'>`
            + `${this.formatValue(flt.value, flt.field.type)}</Value></Ge>`;
            case '>=':
            return `<Geq><FieldRef Name='${flt.field.internalName}' /><Value Type='${flt.field.type}'>`
            + `${this.formatValue(flt.value, flt.field.type)}</Value></Geq>`;
            case 'Is Null':
            return `<IsNull><FieldRef Name='${flt.field.internalName}' /></IsNull>`;
            case 'Is Not Null':
            return `<IsNotNull><FieldRef Name='${flt.field.internalName}' /></IsNotNull>`;
            case 'Starts With':
            return `<BeginsWith><FieldRef Name='${flt.field.internalName}' /><Value Type='${flt.field.type}'>`
            + `${this.formatValue(flt.value, flt.field.type)}</Value></BeginsWith>`;
            default:
            return '';
        }
    }

    private formatValue(val, type): string {
        switch (type) {
            case 'DateTime':
                try {
                return new Date(val).toISOString();
                } catch (e) {
                return val;
                }
                case 'Lookup':
                case 'LookupMulti':
                case 'UserMulti':
                case 'User':
                    return val.value;
            default:
                return val;
        }
    }
}
